// extracted by mini-css-extract-plugin
export default {"sidebar":"_xgm776"};